import type { Lang } from './types';

const vi = {
  cities: ['Hà Nội', 'TP. HCM', 'Đà Nẵng', 'Khác'],
  bodyTypes: [
    'Thư sinh / Mảnh khảnh',
    'Cân đối / Gọn gàng',
    'Cơ bắp / Săn chắc',
    'Đậm người / Đô con',
    'Tạng Gấu / Mũm mĩm',
  ],
  education: ['Cao đẳng', 'Đại học', 'Thạc sĩ', 'Tiến sĩ', 'Giáo sư', 'Khác'],
  income: ['Dưới 10 triệu', '10 - 20 triệu', '20 - 40 triệu', '40-60 triệu', '60-100 Triệu', 'Trên 100 triệu'],
  currentStatus: ['Chưa kết hôn', 'Đã kết hôn với nữ', 'Đã ly hôn', 'Bố đơn thân'],
  livingSpace: ['Sống cùng gia đình', 'Sống 1 mình', 'Sống cùng bạn bè', 'Sống cùng người yêu'],
  orientation: ['Gay', 'Bisexual', 'Bi-curious', 'Pansexual', 'Khác'],
  role: ['Top', 'Bottom', 'Vers Top', 'Vers Bot', 'Fully Versatile', 'Side', 'Trao đổi sau'],
  comingOut: ['Đã công khai hoàn toàn', 'Thoải mái, khá nhiều người biêt', 'Chỉ bạn thân/đồng nghiệp biết', 'Kín đáo tuyệt đối'],
  rel: [
    'Quan hệ 1-1 truyền thống (Chung thủy tuyệt đối về cả tình cảm và tình dục)',
    'Quan hệ cởi mở (Cam kết về tình cảm, nhưng cởi mở về trải nghiệm tình dục bên ngoài)',
    'Tìm hiểu chậm rãi (Hẹn hò trải nghiệm, để mọi chuyện tiến triển tự nhiên)',
    'Bạn đời tri kỷ / Người đồng hành (Tập trung vào sự thấu hiểu, chia sẻ cuộc sống, tình cảm là chính)',
  ],
  personality: ['Điềm đạm/Chín chắn', 'Độc lập/Mạnh mẽ', 'Hài hước/Thú vị', 'Sâu sắc/Tình cảm', 'Lý trí/Thực tế'],
  pros: [
    'Rất biết lắng nghe', 'Nấu ăn ngon', 'Hay làm trò', 'Ôn hòa', 'Luôn đúng giờ', 'Sạch sẽ', 'Gọn gàng',
    'Ấm áp', 'Thơm tho', 'Chiều chuộng người yêu', 'Biết nhường nhịn', 'Thẳng thắn', 'Tử Tế', 'Quyết đoán',
    'Tinh Tế', 'Thông minh',
  ],
  cons: [
    'Mù đường nặng', 'Hay overthinking (Nghĩ nhiều)', 'Rep tin nhắn chậm', 'Hơi bừa bộn', 'Có chút ghen tuông',
    'Hay dỗi', 'Tham công tiếc việc', 'Ngủ ngáy', 'Lười ra đường', 'Hơi kén ăn', 'Hay than vãn', 'Nóng tính',
    'Gia trưởng', 'Dễ khóc', 'Hay im lặng', 'Thích kiểm soát',
  ],
  substances: [
    'Không hút thuốc', 'Có hút thuốc', 'Không rượu bia', 'Uống rượu xã giao', 'Thích rượu/bia', 'Lối sống tiệc tùng',
  ],
  energy: ['Hướng ngoại', 'Hướng nội', 'Lowkey Kín tiếng', 'Tuỳ tâm trạng'],
  lifestyle: ['Cuồng công việc', 'Cân Bằng', 'Cuồng thể thao', 'Thích chill', 'Người của gia đình'],
  hobbies: [
    'Du lịch', 'Khám phá', 'Hưởng thụ', 'Ngoại giao', 'Nghệ thuật', 'Xem phim', 'Nghe nhạc', 'Đọc truyện/sách',
    'Thể Thao', 'Thể hình', 'Chơi game', 'Boardgame',
  ],
  love: [
    'Cử chỉ thân mật (Skinship)', 'Chia sẻ/Tâm sự sâu', 'Hành động thực tế', 'Tặng quà', 'Đi Date',
    'Chăm sóc người yêu', 'Thích được chiều chuộng', 'Ga lăng/Chủ động',
  ],
  futurePlans: [
    'Muốn kết hôn với nam', 'Muốn sống cùng nam', 'Muốn sống 1 mình', 'Không muốn kết hôn với nam', 'Muốn kết hôn với nữ',
  ],
  futureKids: [
    'Đã có con riêng và không muốn có con chung', 'Muốn có con chung', 'Không muốn có con', 'Tùy thuộc vào người yêu',
  ],
  financeShared: [
    'Một người gánh vác tài chính', 'Góp quỹ chung', 'Sằng phẳng chia đôi', 'Độc lập hoàn toàn', 'Không quan trọng chuyện tiền bạc',
  ],
  financeMindset: ['Tích luỹ & An toàn', 'Cân Bằng', 'Trải nghiệm & Hưởng thụ', 'Đầu tư & mạo hiểm'],
  sexView: ['Cốt lõi gắn kết', 'Quan trọng nhưng cần cảm xúc', 'Không quá quan trọng'],
  age: ['18 đến 25', '25 đến 35', '35 đến 45', '45 đến 60', 'Trên 60', 'Tất cả'],
  partnerRole: ['Top', 'Bottom', 'Vers Top', 'Vers Bot', 'Fully Versatile', 'Side', 'Tất cả'],
  partnerBody: ['Thư sinh', 'Cân đối', 'Cơ bắp', 'Đậm người', 'Tạng Gấu', 'Không quan trọng'],
  priority: ['Ngoại hình', 'Tính cách', 'Tài Chính', 'Tuổi tác', 'Học Vấn', 'Địa Vị'],
  redflag: [
    'Trùng Role với tôi', 'Tìm kiếm mối quan hệ mở (Open)', 'Có thói quen hút thuốc/party',
    'Dự định kết hôn giả với nữ', 'Ngược quan điểm chuyện con cái', 'Yêu xa (Khác thành phố)', 'Chênh lệch quá xa',
  ],
} as const;

const en = {
  cities: ['Hanoi', 'Ho Chi Minh City', 'Da Nang', 'Other'],
  bodyTypes: [
    'Slim / Petite',
    'Balanced / Neat',
    'Muscular / Toned',
    'Stocky / Solid',
    'Bear / Chubby',
  ],
  education: ['College', "Bachelor's", "Master's", 'PhD', 'Professor', 'Other'],
  income: ['Under 10M VND', '10–20M VND', '20–40M VND', '40–60M VND', '60–100M VND', 'Over 100M VND'],
  currentStatus: ['Never married', 'Married to a woman', 'Divorced', 'Single father'],
  livingSpace: ['With family', 'Living alone', 'With roommates', 'With partner'],
  orientation: ['Gay', 'Bisexual', 'Bi-curious', 'Pansexual', 'Other'],
  role: ['Top', 'Bottom', 'Vers Top', 'Vers Bottom', 'Fully Versatile', 'Side', 'Discuss later'],
  comingOut: ['Fully out', 'Comfortable — many people know', 'Only close friends/colleagues know', 'Completely discreet'],
  rel: [
    'Traditional monogamy (Fully committed emotionally and sexually)',
    'Open relationship (Emotional commitment, open to sexual experiences outside)',
    'Slow burn dating (Take time, let things unfold naturally)',
    'Life partner / Companion (Focus on understanding, shared life, emotional bond)',
  ],
  personality: ['Calm/Mature', 'Independent/Strong', 'Funny/Playful', 'Deep/Emotional', 'Rational/Practical'],
  pros: [
    'Great listener', 'Cooks well', 'Entertaining', 'Gentle', 'Always on time', 'Clean', 'Organized',
    'Warm', 'Smells good', 'Spoils partner', 'Accommodating', 'Direct', 'Kind', 'Decisive',
    'Tasteful', 'Smart',
  ],
  cons: [
    'Terrible sense of direction', 'Overthinks a lot', 'Slow to reply', 'A bit messy', 'A little jealous',
    'Pouts easily', 'Workaholic', 'Snores', 'Lazy to go out', 'Picky eater', 'Complains a lot', 'Hot-tempered',
    'Controlling', 'Cries easily', 'Goes quiet', 'Likes control',
  ],
  substances: [
    'Non-smoker', 'Smoker', 'No alcohol', 'Social drinker', 'Enjoys drinking', 'Party lifestyle',
  ],
  energy: ['Extrovert', 'Introvert', 'Low-key / Discreet', 'Depends on mood'],
  lifestyle: ['Work-driven', 'Balanced', 'Fitness-focused', 'Chill', 'Family-oriented'],
  hobbies: [
    'Travel', 'Exploring', 'Indulging', 'Socializing', 'Arts', 'Movies', 'Music', 'Reading',
    'Sports', 'Fitness', 'Gaming', 'Board games',
  ],
  love: [
    'Physical touch (Skinship)', 'Deep sharing', 'Acts of service', 'Gifts', 'Dates',
    'Caring for partner', 'Likes being pampered', 'Chivalrous/Proactive',
  ],
  futurePlans: [
    'Want to marry a man', 'Want to live with a man', 'Want to live alone', 'Do not want to marry a man', 'Want to marry a woman',
  ],
  futureKids: [
    'Have kids from before — no shared kids', 'Want kids together', 'Do not want kids', 'Depends on partner',
  ],
  financeShared: [
    'One person covers finances', 'Joint fund', 'Split 50/50', 'Fully independent', 'Money not important',
  ],
  financeMindset: ['Save & security', 'Balanced', 'Experience & enjoyment', 'Invest & risk'],
  sexView: ['Core to bonding', 'Important but needs emotion', 'Not that important'],
  age: ['18 to 25', '25 to 35', '35 to 45', '45 to 60', 'Over 60', 'Any age'],
  partnerRole: ['Top', 'Bottom', 'Vers Top', 'Vers Bottom', 'Fully Versatile', 'Side', 'Any'],
  partnerBody: ['Slim', 'Balanced', 'Muscular', 'Stocky', 'Bear', 'Not important'],
  priority: ['Looks', 'Personality', 'Finance', 'Age', 'Education', 'Status'],
  redflag: [
    'Same role as me', 'Looking for open relationship', 'Smoking/party habits',
    'Plans sham marriage with a woman', 'Opposite views on kids', 'Long distance (different city)', 'Too big a gap (age/status/etc.)',
  ],
} as const;

export type FormOptions = { [K in keyof typeof vi]: readonly string[] };

export const formOptions: Record<Lang, FormOptions> = { vi, en };